const p = (seed) => `https://picsum.photos/seed/demo-${seed}/1200/800`;

/**
 * Full-screen demo payloads (GiftDetails shape) for each journey slug.
 * `variant` 0–3 swaps hero/corners like browse tiles.
 */
const VARIANT_SETS = {
  egift: [
    { Image1: p("eg-0a"), image2: p("eg-0b"), image3: p("eg-0c") },
    { Image1: p("eg-1a"), image2: p("eg-1b"), image3: p("eg-1c") },
    { Image1: p("eg-2a"), image2: p("eg-2b"), image3: p("eg-2c") },
    { Image1: p("eg-3a"), image2: p("eg-3b"), image3: p("eg-3c") },
  ],
  anniversary: [
    { Image1: p("an-0a"), image2: p("an-0b"), image3: p("an-0c") },
    { Image1: p("an-1a"), image2: p("an-1b"), image3: p("an-1c") },
    { Image1: p("an-2a"), image2: p("an-2b"), image3: p("an-2c") },
    { Image1: p("an-3a"), image2: p("an-3b"), image3: p("an-3c") },
  ],
  birthday: [
    { Image1: p("bd-0a"), image2: p("bd-0b"), image3: p("bd-0c") },
    { Image1: p("bd-1a"), image2: p("bd-1b"), image3: p("bd-1c") },
    { Image1: p("bd-2a"), image2: p("bd-2b"), image3: p("bd-2c") },
    { Image1: p("bd-3a"), image2: p("bd-3b"), image3: p("bd-3c") },
  ],
  invitation: [
    { Image1: p("in-0a"), image2: p("in-0b"), image3: p("in-0c") },
    { Image1: p("in-1a"), image2: p("in-1b"), image3: p("in-1c") },
    { Image1: p("in-2a"), image2: p("in-2b"), image3: p("in-2c") },
    { Image1: p("in-3a"), image2: p("in-3b"), image3: p("in-3c") },
  ],
  proposal: [
    { Image1: p("pr-0a"), image2: p("pr-0b"), image3: p("pr-0c") },
    { Image1: p("pr-1a"), image2: p("pr-1b"), image3: p("pr-1c") },
    { Image1: p("pr-2a"), image2: p("pr-2b"), image3: p("pr-2c") },
    { Image1: p("pr-3a"), image2: p("pr-3b"), image3: p("pr-3c") },
  ],
  "missing-message": [
    { Image1: p("mm-0a"), image2: p("mm-0b"), image3: p("mm-0c") },
    { Image1: p("mm-1a"), image2: p("mm-1b"), image3: p("mm-1c") },
    { Image1: p("mm-2a"), image2: p("mm-2b"), image3: p("mm-2c") },
    { Image1: p("mm-3a"), image2: p("mm-3b"), image3: p("mm-3c") },
  ],
};

const COPY = {
  egift: {
    Tittle: "Your digital gift card",
    reciever: "Jordan",
    Message:
      "This is a sample e-gift layout. When someone pays and shares a link, their message appears here in full — same cinematic frame you see now.",
    Greetings: "With warm wishes",
    Name: "GifteKart",
  },
  anniversary: {
    Tittle: "Happy Anniversary",
    reciever: "Sam & Riley",
    Message:
      "Every year with you feels like the first. Here is to the memories we have made and those still to come.",
    Greetings: "Still falling for you,",
    Name: "Your partner",
  },
  birthday: {
    Tittle: "Make a wish!",
    reciever: "Casey",
    Message:
      "Hope your day is full of cake, laughter, and everything you have been wishing for. You deserve the best year yet.",
    Greetings: "Celebrate big —",
    Name: "The whole crew",
  },
  invitation: {
    Tittle: "You are invited",
    reciever: "Dear friends",
    Message:
      "We would love for you to join us for an evening of dinner, music, and celebration. Formal attire. RSVP by the date on your invite.",
    Greetings: "With love,",
    Name: "Avery & Morgan",
  },
  proposal: {
    Tittle: "One question…",
    reciever: "Taylor",
    Message:
      "You have made ordinary days feel extraordinary. Will you take this next chapter with me?",
    Greetings: "Forever yours,",
    Name: "Jamie",
  },
  "missing-message": {
    Tittle: "Thinking of you",
    reciever: "Friend",
    Message:
      "I have been thinking about you. No pressure to reply right away — I just wanted you to know you matter.",
    Greetings: "Take care,",
    Name: "Someone who cares",
  },
};

/** Per-occasion variant names — shown on product page chips and sample header. */
const VARIANT_NAMES = {
  egift:            ["Classic Elegance", "Modern Charm",    "Vibrant Joy",    "Subtle Grace"],
  anniversary:      ["Golden Moments",  "Forever Yours",   "Years of Love",  "Timeless Bond"],
  birthday:         ["Confetti Party",  "Birthday Bash",   "Wish & Cake",    "Neon Fiesta"],
  invitation:       ["Garden Bloom",    "Royal Floral",    "Blossom Aisle",  "Eternal Vows"],
  proposal:         ["The Question",    "Forever After",   "Say Yes",        "Ring of Love"],
  "missing-message":["Gentle Words",    "Thinking of You", "Warm Thoughts",  "From the Heart"],
};

export function getVariantName(occasionSlug, variantIndex) {
  const slug = occasionSlug in VARIANT_NAMES ? occasionSlug : "egift";
  const names = VARIANT_NAMES[slug];
  const vi = Math.max(0, Math.min(names.length - 1, Number(variantIndex) || 0));
  return names[vi];
}

export function buildPredefinedDemoGift(occasionSlug, variantIndex = 0) {
  const slug = occasionSlug in COPY ? occasionSlug : "egift";
  const imgs = VARIANT_SETS[slug] || VARIANT_SETS.egift;
  const vi = Math.max(0, Math.min(imgs.length - 1, Number(variantIndex) || 0));
  const base = COPY[slug];
  const layer = imgs[vi];
  return {
    ...base,
    Image1: layer.Image1,
    image2: layer.image2,
    image3: layer.image3,
  };
}
